"use client"

import { Trans } from "@lingui/react/macro"
import {
  Skeleton,
  buttonVariants,
  cn,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { WalletConnectMoleculeReatom } from "./store.reatom"

function ConnectButtonSkeleton() {
  return <Skeleton className="h-9 w-[85px]" />
}

export const WalletConnectButton = reatomComponent(() => {
  const { connectWalletButton, initialized } = useMolecule(
    WalletConnectMoleculeReatom,
  )
  const { ConnectWalletButton } = connectWalletButton()
  const isInitialized = initialized()

  if (!isInitialized) return <ConnectButtonSkeleton />

  return <ConnectWalletButton />
}, "WalletConnectButton")
